import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Wrapper')(() => css({
    display: 'flex',
    flexDirection: 'column',
    mx: ['20px', '20px', 'l'],
    my: 'l',
    gap: ['default', 'default', 'l'],
}));
themeStyles.addBaseStyles('Container')(() => css({
    borderRadius: '3px',
    border: 1,
    borderColor: 'grey.2',
    backgroundColor: 'white',
    padding: 'default',
}));
themeStyles.addBaseStyles('CtaButtonsGrid')(css({
    display: 'grid',
    rowGap: 'm',
    gridAutoRows: '1fr',
}));
themeStyles.addBaseStyles('Title')(() => css({
    fontFamily: 'bold',
    mb: 'm',
}));
themeStyles.addBaseStyles('Button')(() => css({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));
export default themeStyles;
